import Phaser from 'phaser'

/** Loads assets and shows progress. Real games put their atlas/audio loading here. */
export class BootScene extends Phaser.Scene {
  constructor() { super('Boot') }

  preload() {
    const { width, height } = this.scale
    const bar = this.add.rectangle(width / 2 - 200, height / 2, 0, 24, 0xE4572E).setOrigin(0, 0.5)
    this.load.on('progress', (p: number) => bar.setSize(400 * p, 24))
    // this.load.atlas('main', 'assets/main.png', 'assets/main.json')
  }

  create() { this.scene.start('Menu') }
}
